import React, { Component } from 'react';
import { connect } from 'react-redux';
import Heading from '../Heading';
import CertainWorksPopup from './CertainWorksPopup';
import FontAwesome from 'react-fontawesome';
import music from '../../assets/music.svg';
import photo from '../../assets/photo.svg';
import text from '../../assets/text.svg';
import video from '../../assets/video.svg';
import actions from '../../redux/actions';
import {
  /*COST_SIMPLE,*/ COST_STANDARD,
  COST_UNPUBLISHED_WORK,
  COST_PHOTOGRAPH_COLLECTION,
} from '../../constants';

class ProductType extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openModal: false,
      showTitle: [false, false, false, false],
    };
  }

  componentWillMount() {
    if (this.props.profile.id) {
      this.props.getUserWorks(this.props.profile.id);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.profile !== prevProps.profile) {
      if (this.props.profile.id) {
        this.props.getUserWorks(this.props.profile.id);
      }
    }
  }

  handleClick(type) {
    this.props.assignAttribute('type', type);
    // this.props.router.push('/copyright-reg/questionnaire');

    this.props.router.push('/copyright-reg/copyright-type');
  }

  openModal(e) {
    e.preventDefault();
    this.setState({ openModal: true });
  }

  closeModal() {
    this.setState({ openModal: false });
  }

  handleShowTitle(e, index) {
    e.preventDefault();

    let { showTitle } = this.state;
    showTitle[index] = !showTitle[index];
    this.setState({ showTitle });
  }

  render() {
    const { showTitle } = this.state;

    return (
      <div className="product-type">
        <Heading text="What kind of work would you like to register?" />
        <div className="types">
          {this.props.workTypes.map((workType, i) => {
            let src = null;
            let title = '';
            switch (workType.name) {
              case 'Music':
                src = music;
                title = workType.name;
                break;
              case 'Video':
                src = video;
                title = workType.name;
                break;
              case 'Image':
                src = photo;
                title = workType.name;
                break;
              case 'Document':
                src = text;
                title = 'Literature';
                break;
              default:
                break;
            }
            return (
              <div key={i} onClick={() => this.handleClick(workType.id)}>
                <img src={src} alt={title} />
                <h1>{title}</h1>
              </div>
            );
          })}
        </div>

        <br />
        <br />
        <h1 className={`title ${!showTitle[0] && 'collapsed-title'}`}>
          <a onClick={(e) => this.handleShowTitle(e, 0)}>
            {showTitle[0] ? (
              <FontAwesome name="caret-up" />
            ) : (
              <FontAwesome name="caret-down" />
            )}
            Why should I use Cosynd to file my application?
          </a>
        </h1>
        <div className={`sub-title ${showTitle[0] ? 'expanded' : 'collapsed'}`}>
          <p>
            Cosynd is a faster, friendlier, and more affordable way to register
            your copyrights compared to other services. We'll only ask you to
            provide the information that is necessary in order to compile your
            application and file it on your behalf with the U.S. Copyright
            Office. Click on an image above to get started.
          </p>
        </div>

        <h1 className={`title ${!showTitle[1] && 'collapsed-title'}`}>
          <a onClick={(e) => this.handleShowTitle(e, 1)}>
            {showTitle[1] ? (
              <FontAwesome name="caret-up" />
            ) : (
              <FontAwesome name="caret-down" />
            )}
            How many applications will I need to file?
          </a>
        </h1>
        <div
          className={`sub-title ${
            showTitle[1] ? 'expanded pricing' : 'collapsed'
          }`}
        >
          <p>
            If you are registering multiple copyrights, you may have to file
            multiple applications to cover them. To find out how many
            applications you might need, you can&nbsp;
            <a target="_blank" href="https://www.cosynd.com/calculator">
              use this application calculator
            </a>
            .
          </p>
        </div>

        <h1 className={`title ${!showTitle[2] && 'collapsed-title'}`}>
          <a onClick={(e) => this.handleShowTitle(e, 2)}>
            {showTitle[2] ? (
              <FontAwesome name="caret-up" />
            ) : (
              <FontAwesome name="caret-down" />
            )}
            What should I have ready before | begin?
          </a>
        </h1>
        <div className={`sub-title ${showTitle[2] ? 'expanded' : 'collapsed'}`}>
          <ol>
            <li>
              The addresses and country of citizenship/domicile of your
              co-authors
            </li>
            <li>The addresses of any additional claimants on your copyright</li>
            <li>
              The year of completion, date of publication, and the nation of
              publication for the work(s)
            </li>
          </ol>
        </div>

        <h1 className={`title ${!showTitle[3] && 'collapsed-title'}`}>
          <a onClick={(e) => this.handleShowTitle(e, 3)}>
            {showTitle[3] ? (
              <FontAwesome name="caret-up" />
            ) : (
              <FontAwesome name="caret-down" />
            )}
            What is a copyright?
          </a>
        </h1>
        <div className={`sub-title ${showTitle[3] ? 'expanded' : 'collapsed'}`}>
          <p>
            Copyright is a form of protection provided to the authors of
            published and unpublished "original works of authorship," such as
            literary, dramatic, musical, artistic, and certain other
            intellectual works. This protection also includes the exclusive
            right to reproduce, distribute, create derivative works of, publicly
            perform (for certain types of works), or display (for certain types
            of works) a work and to authorize others to do so too.
          </p>
          <p>
            The{' '}
            <a
              target="_blank"
              href="https://www.copyright.gov/title17/92chap1.html"
            >
              U.S. Copyright Act
            </a>{' '}
            grants to  copyright holders the exclusive right to do and to
            authorize others to do the following:
          </p>
          <ul>
            <li>Reproduce the work in copies or phonorecords;</li>
            <li>Prepare derivative works based upon the work;</li>
            <li>
              Distribute copies or phonorecords of the work to the public by
              sale or other transfer of ownership, or by rental, lease, or
              lending;
            </li>
            <li>
              Perform the work publicly, in the case of literary, musical,
              dramatic, and choreographic works, pantomimes, and motion pictures
              and other audiovisual works;
            </li>
            <li>
              Display the work publicly, in the case of literary, musical,
              dramatic, and choreographic works, pantomimes, and pictorial,
              graphic, or sculptural works, including the individual images of a
              motion picture or other audiovisual work; and
            </li>
            <li>
              Perform the work publicly (in the case of sound recordings*) by
              means of a digital audio transmission.
            </li>
          </ul>
          <p>
            There are a number of benefits to having your content registered
            with the U.S. Copyright Office:
          </p>
          <ul>
            <li>You receive a certificate of registration</li>
            <li>
              Before an infringement suit may be filed in court, registration is
              necessary for works of U.S. origin.
            </li>
            <li>
              By registering your content, you may be eligible to collect
              statutory damages and attorney&#39;s fees from litigation.
            </li>
            <li>
              There is a public record of your ownership, your collaborators’
              ownership, and the other relevant details of your content.
            </li>
            <li>
              If registration occurs within 5 years of the publication of your
              content, your registration is considered prima facie evidence in a
              court of law.
            </li>
            <li>
              You can record the registration with the U.S. Customs Service for
              protection against the importation of infringing copies.
            </li>
          </ul>

          <p>
            In order to have Cosynd register your eligible works with the
            Copyright Office, please answer the following questions to determine
            the type of application that will be submitted on your behalf:
          </p>
        </div>

        <h1 className={`title ${!showTitle[4] && 'collapsed-title'}`}>
          <a onClick={(e) => this.handleShowTitle(e, 4)}>
            {this.state.showTitle[4] ? (
              <FontAwesome name="caret-up" />
            ) : (
              <FontAwesome name="caret-down" />
            )}
            Why should I register at all?
          </a>
        </h1>
        <div className={`sub-title ${showTitle[4] ? 'expanded' : 'collapsed'}`}>
          <p>
            Registering your works can pay off in big ways—especially when
            things go wrong. Copyright owners that have registered{' '}
            <b>
              can use their registration as a public record of ownership, file
              an infringement suit, collect damages of $150,000 per work plus
              attorney fees
            </b>
            , and more.
          </p>
        </div>

        <h1 className={`title ${!showTitle[5] && 'collapsed-title'}`}>
          <a onClick={(e) => this.handleShowTitle(e, 5)}>
            {showTitle[5] ? (
              <FontAwesome name="caret-up" />
            ) : (
              <FontAwesome name="caret-down" />
            )}
            What can I register?
          </a>
        </h1>
        <div className={`sub-title ${showTitle[5] ? 'expanded' : 'collapsed'}`}>
          <p>
            You can use Cosynd to register just one work or a collection of
            works (like an album) with only one application if the authors,
            owners, their roles, and the publishing information are identical
            across all of the works. Otherwise, you will need to create separate
            applications for each work. Certain works are{' '}
            <a onClick={(e) => this.openModal(e)}>
              not eligible for copyright protection
            </a>
            . You cannot use Cosynd to register works made by anonymous authors.
          </p>
          <p>
            Need help? Check out our{' '}
            <a
              href="https://cosynd.zendesk.com/hc/en-us/articles/360000022367-How-to-Register-Your-Copyrights-with-the-U-S-Copyright-Office-Using-Cosynd"
              target="_blank"
            >
              step-by-step guide on using Cosynd to register your copyrights
              here
            </a>
            .
          </p>
        </div>

        <h1 className={`title ${!showTitle[6] && 'collapsed-title'}`}>
          <a onClick={(e) => this.handleShowTitle(e, 6)}>
            {showTitle[6] ? (
              <FontAwesome name="caret-up" />
            ) : (
              <FontAwesome name="caret-down" />
            )}
            What does it cost to file an application on my behalf?
          </a>
        </h1>
        <div
          className={`sub-title ${
            showTitle[6] ? 'expanded pricing' : 'collapsed'
          }`}
        >
          <p>
            It costs $35.00 to file an application plus the federal filing fees
            set by the Copyright Office. Members of official Cosynd Partners pay
            $25.00 per application plus federal filing fees. Want to partner
            with Cosynd? contact
            <a href="mailto:hello@cosynd.com"> hello@cosynd.com)</a>
          </p>
          <br />
          <p>
            <b>Federal Filing Fees:</b>
          </p>
          <ul className={`${showTitle[6] ? 'expanded' : 'collapsed'}`}>
            {/* <li>
                            <b>Simple Application (${COST_SIMPLE} federal filing fee)</b> - An application containing 1 work by 1 author.
                            </li> */}
            <li>
              <b>Standard Application (${COST_STANDARD} federal filing fee)</b>{' '}
              - An application containing 1 title or multiple titles by multiple
              authors/owners that have been published (released).
            </li>
            <li>
              <b>
                A Group of Unpublished Works (${COST_UNPUBLISHED_WORK} federal
                filing fee)
              </b>{' '}
              - An application containing a group of unpublished (unreleased)
              titles.
            </li>
            <li>
              <b>
                A Group of Photographs (${COST_PHOTOGRAPH_COLLECTION} federal
                filing fee)
              </b>{' '}
              - A group of published or unpublished photographs.
              <br />
              <br />
              <em>
                *Note, the authors/owners must be identical for all of the works
                listed on your application.
              </em>
            </li>
          </ul>
        </div>

        <CertainWorksPopup
          open={this.state.openModal}
          onClose={() => this.closeModal()}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  workTypes: state.global.workTypes,
  profile: state.profile,
});

const mapDispatchToProps = (dispatch) => ({
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
  getUserWorks: (userId) => {
    dispatch(actions.getUserWorks(userId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductType);



// WEBPACK FOOTER //
// src/components/Copyright/ProductType.jsx